export const getShortMonth = (monthNb) => {
  switch (monthNb) {
    case 1:
      return "J";
    case 2:
      return "F";
    case 3:
      return "M";
    case 4:
      return "A";
    case 5:
      return "M";
    case 6:
      return "J";
    case 7:
      return "J";
    case 8:
      return "A";
    case 9:
      return "S";
    case 10:
      return "O";
    case 11:
      return "N";
    case 12:
      return "D";
    default:
      break;
  }
};

export const getMonth = (monthNb) => {
  switch (monthNb) {
    case 1:
      return "Janvier";
    case 2:
      return "Février";
    case 3:
      return "Mars";
    case 4:
      return "Avril";
    case 5:
      return "Mai";
    case 6:
      return "Juin";
    case 7:
      return "Juillet";
    case 8:
      return "Août";
    case 9:
      return "Septembre";
    case 10:
      return "Octobre";
    case 11:
      return "Novembre";
    case 12:
      return "Décembre";

    default:
      break;
  }
};

export const getDay = (day) => {
  switch (day) {
    case 0:
      return "Lundi";
    case 1:
      return "Mardi";
    case 2:
      return "Mercredi";
    case 3:
      return "Jeudi";
    case 4:
      return "Vendredi";
    case 5:
      return "Samedi";
    case 6:
      return "Dimanche";

    default:
      return "Date invalide";
  }
};
